import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesInventory } from "../../constants";
import { MissingItemsListItem } from "../../inventory.types";

export const requestMissingItems = async (
  params: GetListRequestParams
): Promise<GetListResponse<MissingItemsListItem>> => {
  return await instance.get(ApiRoutesInventory.AllMissingItems, { params });
};
